/**
 * Form Block - Other Link Redirect View Script
 *
 * On submit, replaces [field_name] tokens in the redirect URL template
 * with the corresponding form field values and navigates to the result.
 */
document
	.querySelectorAll(
		'form[data-block-name="brandy/form"][data-action="other_link"]'
	)
	.forEach( ( form ) => {
		form.addEventListener( 'submit', ( event ) => {
			event.preventDefault();

			const template = form.getAttribute( 'data-redirect-url' );
			if ( ! template ) return;

			const data = new FormData( form );

			// Replace [field_name] tokens with URL-encoded form values.
			const url = template.replace( /\[([^\]]+)\]/g, ( _, name ) =>
				encodeURIComponent( data.get( name ) ?? '' )
			);

			window.location.href = url;
		} );
	} );
